import * as React from 'react';
import ReactDOM from 'react-dom';
import Moment from 'moment';
import { checkersQueueColumns, checkersQueueOptions } from './config';
import Datatable from '../../DataTable';
import { connect } from 'react-redux';
import { Button, Col, Form } from 'react-bootstrap';
import { UserInfo, hasPermission } from '../../Login/common/defaults';
import { eCheckersQueue } from './controller/CheckersQueueController';
import {
  DateRangePicker,
} from 'react-dates';
import { extendMoment } from 'moment-range';
import * as urls from '../../shared/urls';
import {
  searchCheckers,
  openReport,
  assignAndOpen,
  unAssign,
} from './redux-objects/actions';
import './assets/checkersQueue.scss';
import { IWorkflowItemStep } from '../../../common/sharedTypes';
import * as documentDownloadService from '../../../services/documentDownloadService';
import { toast } from 'react-toastify';


import { getFrontSheetData } from '../../PrintPDF/redux-objects/actions';

import ViewAllButton from '../../DocumentViewer/ViewAllButton';
import { Provider } from 'react-redux';
import store from '../../../store/Store';
import rootReducer from '../../../store/Reducers';
import MergedIndicator from '../common/MergedIndicator';
import { QueueStartDate } from '../common';
const reduxStore = store({}, rootReducer);

const moment = extendMoment(Moment);

interface ICheckersQueueFromState {
  currentUser: UserInfo;
  webServiceURL: string;
  history: any;
  queueToShow: eCheckersQueue;
  workflowItemSteps: IWorkflowItemStep[];
}

interface ICheckersQueueFromActions {
  searchCheckers?: (url: string) => void;
  openReport?: (id: number) => Promise<void>;
  assignAndOpen?: (
    url: string,
    stepItemId: number,
    assignToId: number
  ) => Promise<void>;
  unAssign?: (url: string, stepItemId: number) => Promise<void>;
  getFrontSheetData?: (url: string, reportId: any) => Promise<any>;
}

interface ICheckersQueueLocalState {
  showModal: boolean;
  startDate: Moment.Moment;
  endDate: Moment.Moment;
  focusedInput: any;
  showCheckers: boolean;
  selectedItem: any;
  formIsReadOnly: boolean;
  userOnly: boolean;
  assignedOnly: boolean;
}

type ICheckersQueueProps = ICheckersQueueFromActions & ICheckersQueueFromState;

export class CheckersQueue extends React.Component<
  ICheckersQueueProps,
  ICheckersQueueLocalState
> {
  constructor(props: ICheckersQueueProps) {
    super(props);

    this.state = {
      showModal: false,
      startDate: moment(QueueStartDate),
      endDate: moment(),
      focusedInput: null,
      showCheckers: false,
      selectedItem: null,
      formIsReadOnly: false,
      userOnly: false,
      assignedOnly: false,
    };
  }

  private assignedOnly: string = 'CheckersAssignedOnlyCheckbox';
  private userOnly: string = 'CheckersUserOnlyCheckbox';

  onViewPdfClick = () => {
    window.open('/Form40.pdf');
  };

  openReportToRead = (cellData, rowData) => {
    this.setState({ selectedItem: cellData, showCheckers: true });
  };

  handleAssignAndOpen(cellData: string, rowData: any) {
    const workflowItemStep = rowData;
    if (rowData.assignedTo == this.props.currentUser.id) {
      this.props.openReport(workflowItemStep).then(() => {
        this.props.history.push('/CheckerReview');
      });
    } else {
      this.props
        .assignAndOpen(
          urls.ASSIGN_WORKFLOW_ITEM_STEP,
          workflowItemStep.id,
          this.props.currentUser.id
        )
        .then(() => {
          this.props.history.push('/CheckerReview');
        });
    }
  }

  handleOpenImage(crashId: string) {
    documentDownloadService.openOnBaseImage(crashId, null).then((x) => {
      if (x === 'generated') {
        toast.info('OnBase Image not found - Image generated from data', {
          autoClose: false,
        });
      } else if (x === 'mock') {
        toast.info('OnBase mocked - Image generated from data', {
          autoClose: false,
        });
      }
    });
  }

  loadCheckers() {
    const { webServiceURL } = this.props;
    let uri = `${webServiceURL}${urls.SEARCH_CHECKERS_QUEUE}`;
    let persistentUserOnly = this.getLocalStorageItem(
      'CheckersUserOnlyCheckbox'
    );
    let persistentAssignedOnly = this.getLocalStorageItem(
      'CheckersAssignedOnlyCheckbox'
    );
    const params = {
      userOnly: persistentUserOnly ? persistentUserOnly : false,
      assignedOnly: persistentAssignedOnly ? persistentAssignedOnly : false,
      startDate: this.state.startDate.toDate().toUTCString(),
      endDate: this.state.endDate.toDate().toUTCString(),
      workflowStatus: 1,
    };

    const esc = encodeURIComponent;
    const query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;
    this.props.searchCheckers(uri);
  }

  handleClose = () => {
    this.setState({ showCheckers: false });
  };

  componentDidMount() {
    this.loadCheckers();
  }

  getLocalStorageItem(key) {
    try {
      let item: string = window.localStorage.getItem(key);
      let checkboxFlag = null;
      if (item == 'true') checkboxFlag = true;
      if (item == 'false') checkboxFlag = false;
      return checkboxFlag ? checkboxFlag : null;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  setLocalStorageItem(key, value) {
    window.localStorage.setItem(key, value);
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      console.log(error);
    }
  }

  handleFocusChange = (focusedInput) => this.setState({ focusedInput });

  handleAssignedOnlyCheck(isChecked: any) {
    this.setLocalStorageItem(this.assignedOnly, isChecked);
    this.setState({ assignedOnly: isChecked }, () => {
      this.loadCheckers();
    });
  }

  getFrontSheet = (rowData) => {
    console.log('workflowItemStep from checker queue', rowData);
    const reportId = rowData?.workflowItem?.reportId;

    documentDownloadService.getFrontSheet(reportId);
  };

  handleUnAssign(event: React.MouseEvent<HTMLElement>, rowData: any) {
    this.props.unAssign(urls.UNASSIGN_WORKFLOW_ITEM_STEP, rowData).then(() => {
      toast.success('Unassigned');
    });
  }

  handleUserCheck(userChecked: any) {
    this.setLocalStorageItem(this.userOnly, userChecked);
    this.setState({ userOnly: userChecked }, () => {
      this.loadCheckers();
    });
  }

  handleDatesChanged(startDate: any, endDate: any) {
    if (startDate && endDate) {
      this.setState({ startDate, endDate }, () => {
        this.loadCheckers();
      });
    }
  }
  checkersQueueColumnDefs = [
    {
      targets: 0,
      orderable: false,
      width: '250px',
      createdCell: (td, cellData, rowData, row, col) => {
        return ReactDOM.render(
          <React.Fragment>
            <div className='buttonColumn'>
              <Provider store={reduxStore}>
                <ViewAllButton
                  reportId={rowData.workflowItem.reportId}
                  className=''
                />
              </Provider>
              {'  '}
              {'  '}
              {(rowData.assignedTo == null ||
                rowData.assignedTo == this.props.currentUser.id) && (
                  <Button
                    variant='outline-primary'
                    size='sm'
                    data-id={cellData}
                    onClick={(e) => this.handleAssignAndOpen(cellData, rowData)}
                  >
                    {'   '}
                    {rowData.assignedTo == this.props.currentUser.id
                      ? 'Continue'
                      : 'Review'}
                  </Button>
                )}
              {'   '}
              {rowData.assignedTo != null &&
                hasPermission(this.props.currentUser, 'Reviewer') && (
                  <Button
                    variant='outline-danger'
                    size='sm'
                    data-id={cellData}
                    onClick={(e) => this.handleUnAssign(cellData, rowData)}
                  >
                    {'   '}
                    Unassign
                  </Button>
                )}
              {'   '}
              {hasPermission(this.props.currentUser, 'Reviewer') && (
                <Button
                  variant='outline-dark'
                  size='sm'
                  data-id={cellData}
                  onClick={(e) => this.getFrontSheet(rowData)}
                >
                  {'   '}
                  Load FrontSheet
                </Button>
              )}
              {'   '}
              {hasPermission(this.props.currentUser, 'Reviewer') && (
                <Button
                  variant='outline-info'
                  size='sm'
                  data-id={cellData}
                  onClick={(e) => this.handleOpenImage(cellData)}
                >
                  {'   '}
                  Open Image
                </Button>
              )}
            </div>
          </React.Fragment>,
          td
        );
      },
    },
    {
      targets: 1,
      createdCell: (td, cellData, rowData, row, col) =>
        ReactDOM.render(
          <>{cellData}
            <MergedIndicator
              supplementedReports={rowData.workflowItem.report.supplementedReports}
              reportsMergedToThis={rowData.workflowItem.report.reportsMergedToThis}
            />
          </>,
          td)
    },
    {
      targets: 8,
      visible: false,
    },
  ];

  render() {
    return (
      <React.Fragment>
        <h4>
          {this.props.queueToShow == eCheckersQueue.CheckersReview
            ? 'Checkers Queue'
            : 'Checkers Review Queue'}
        </h4>
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId='checkersQueueStartDate'>
              <Form.Label>Created Date</Form.Label>
              <br />
              <DateRangePicker
                startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                startDateId='checkersQueueStartDate' // PropTypes.string.isRequired,
                endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                endDateId='checkersQueueEndDate' // PropTypes.string.isRequired,
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                } // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                } // PropTypes.func.isRequired,
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
            </Form.Group>
            <Form.Group controlId='formBasicCheckbox'>
              <Form.Check
                type='checkbox'
                label=' Show only Assigned'
                checked={this.getLocalStorageItem(this.assignedOnly)}
                onChange={(e) => this.handleAssignedOnlyCheck(e.target.checked)}
              />
            </Form.Group>
            &nbsp;&nbsp;&nbsp;
            <Form.Group controlId='AssignedMe'>
              <Form.Check
                type='checkbox'
                label=' Show only Assigned to Me'
                checked={this.getLocalStorageItem(this.userOnly)}
                onChange={(e) => this.handleUserCheck(e.target.checked)}
              />
            </Form.Group>
          </Form.Row>
        </Form>
        {this.props.workflowItemSteps &&
          this.props.workflowItemSteps.length > 0 && (
            <Datatable
              {...checkersQueueOptions}
              id='tblCheckersQueue'
              data={this.props.workflowItemSteps}
              columns={checkersQueueColumns}
              columnDefs={this.checkersQueueColumnDefs}
              select={false}
            />
          )}
      </React.Fragment>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    workflowItemSteps: state.CheckersQueue.workflowItemSteps,
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser,
  };
}

const mapDispatchToProps = {
  searchCheckers,
  openReport,
  assignAndOpen,
  unAssign,
  getFrontSheetData,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckersQueue);
